import { createEntityAdapter, EntityState } from '@ngrx/entity';

import { GeozonesGroupItem } from '@services/geozones.service';

export const geozoneGroupsAdapter = createEntityAdapter<GeozonesGroupItem>({
  selectId: (item) => item.id as number,
});

export interface GeozoneGroupsState extends EntityState<GeozonesGroupItem> {
  loading: boolean;
  error?: string;
}

export const initialGeozoneGroupsState: GeozoneGroupsState = geozoneGroupsAdapter.getInitialState({
  loading: false,
  error: undefined,
});
